// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"91e5a806","121":"d2b2d2b0","370":"8cbf02d9","893":"bb8eb1d9"}[chunkId] + ".chunk.js";
};